export const NavigationPaths = {
    CREATE_CAMPAIGN: "/create-campaign",
    TICKET_DETAILS: "/ticket-details",
    EVENT_DETAILS: "/event-details",
    CAMPAIGNS: "/home/events",
    BUSINESSES: "/home/businesses",
    BENEFITS: "/home/benefits",
    MEMBERS: "/home/members",
    APPLICATIONS: "/home/applications"
};